import { pipe, Array as A } from 'effect'
import { orderRacesByCreatedAt, type Race } from 'src/types/domain/Race'

/**
 * Combine the live store history with a one-shot deep fetch.
 *
 * The store holds only the last ~10 rounds but the socket keeps them current;
 * the deep fetch holds a few hundred but is a snapshot from when the panel
 * opened. Overlapping rounds resolve to the STORE copy, which is the one that
 * has this round's settlement events.
 *
 * Result is newest-first and deduplicated by round id.
 */
export const mergeRaceHistory = (
  storeRaces: readonly Race[],
  fetchedRaces: readonly Race[]
): Race[] => {
  const byId = new Map<string, Race>()

  for (const race of fetchedRaces) byId.set(race.uuid, race)
  for (const race of storeRaces) byId.set(race.uuid, race)

  return pipe(Array.from(byId.values()), A.sortBy(orderRacesByCreatedAt))
}
